import React from 'react'
import Pill from '@/components/Pill/Pill'

export type PillBlockProps = {
  text: string
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error'
  size?: 'sm' | 'md' | 'lg'
  clickable?: boolean
  link?: {
    type?: 'reference' | 'custom'
    reference?: {
      relationTo: string
      value: string | any
    }
    url?: string
    label?: string
  }
  blockType: 'pill'
}

export const PillBlock: React.FC<PillBlockProps> = ({
  text,
  variant = 'primary',
  size = 'md',
  clickable = false,
  link,
}) => {
  const handleClick = () => {
    if (link && clickable) {
      if (link.type === 'custom' && link.url) {
        window.open(link.url, '_self')
      } else if (link.type === 'reference' && link.reference) {
        // Handle internal reference navigation
        const href = `/${link.reference.relationTo}/${
          typeof link.reference.value === 'string'
            ? link.reference.value
            : link.reference.value?.slug
        }`
        window.open(href, '_self')
      }
    }
  }

  return (
    <Pill
      variant={variant}
      size={size}
      clickable={clickable}
      onClick={clickable ? handleClick : undefined}
    >
      {text}
    </Pill>
  )
}